var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVestaLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 51,
    viewBox: "0 0 18 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2801 19.61C15.6298 15.4356 13.9794 11.1641 12.4262 6.98971C11.5524 4.75689 10.6787 2.52406 9.80502 0.291238C9.70794 0.0970793 9.61085 0 9.41669 0C9.02837 0 8.54299 0 8.15467 0C8.05759 0 7.86343 0.0970793 7.86343 0.194159C6.79556 2.8153 5.82476 5.53352 4.75689 8.15466C3.59194 11.1641 2.42699 14.2707 1.26203 17.2801C0.873717 18.348 0.485397 19.4159 0 20.5808C0.194159 20.5808 0.194162 20.5808 0.291241 20.5808C1.06788 20.5808 1.84451 20.5808 2.62115 20.5808C2.91238 20.5808 3.00946 20.4837 3.10654 20.2896C3.7861 18.4451 4.46565 16.6006 5.14521 14.8531L6.50431 11.067V10.97C6.69847 10.5816 6.79555 10.0962 6.98971 9.70793C7.4751 8.4459 7.9605 7.08679 8.4459 5.82476C8.54298 5.6306 8.54299 5.43644 8.64007 5.1452C8.93131 5.92184 9.22253 6.60139 9.41669 7.28095C9.90209 8.54298 10.2904 9.70793 10.7758 10.97V11.067L11.9408 14.2707C11.9408 14.2707 11.9408 14.2707 11.9408 14.3677C12.7174 16.4064 13.397 18.4451 14.1736 20.3867C14.2707 20.5808 14.3677 20.6779 14.5619 20.6779C15.4356 20.6779 16.2123 20.6779 17.086 20.6779C17.183 20.6779 17.2801 20.6779 17.3772 20.6779C17.4743 20.2896 17.3772 19.9013 17.2801 19.61Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0086 48.3452H2V50.9664H15.0086V48.3452Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0086 39.4141H2V42.0352H15.0086V39.4141Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0086 30.3857H2V33.0069H15.0086V30.3857Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVestaLogoSmall);
export default __webpack_public_path__ + "static/media/vesta-logo-small.d5485406.svg";
export { ForwardRef as ReactComponent };